"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const BaseAlert = (_a) => {
    var { variant, styleVariant, open, title, body, options, onClose, alertProps, action } = _a, providerOpts = __rest(_a, ["variant", "styleVariant", "open", "title", "body", "options", "onClose", "alertProps", "action"]);
    return providerOpts.unmountOnClose && !open ? (react_1.default.createElement("div", null)) : (react_1.default.createElement(material_1.Snackbar, { open: open, autoHideDuration: providerOpts.forceClose ? undefined : options === null || options === void 0 ? void 0 : options.duration, onClose: onClose, anchorOrigin: options === null || options === void 0 ? void 0 : options.location, action: action, ClickAwayListenerProps: (options === null || options === void 0 ? void 0 : options.disableClickAwayListener) ? {
            mouseEvent: false,
            touchEvent: false,
            onClickAway: () => null
        }
            : undefined },
        react_1.default.createElement(material_1.Alert, Object.assign({}, alertProps, { onClose: onClose, severity: variant, action: action, variant: styleVariant, classes: options === null || options === void 0 ? void 0 : options.classes }),
            title && react_1.default.createElement(material_1.AlertTitle, { className: alertProps === null || alertProps === void 0 ? void 0 : alertProps.className }, title),
            body)));
};
exports.default = BaseAlert;
